import { useMemo } from 'react';
import { ContactFormParams } from 'assets/js/pages/contacts/contactFormParams';
import { useQueryParams } from 'customHooks/useQueryParams';

const useContactFormSections = () => {
    const queryParams = useQueryParams<ContactFormParams>();
    const only = useMemo(() => queryParams.only || [], [queryParams.only]);

    const sections = useMemo(
        () => ({
            profile: only.length === 0,
            social: only.includes('social'),
            engage: only.includes('engage'),
            phones: only.includes('phones'),
            emails: only.includes('emails'),
            customFields: only.includes('custom-fields'),
        }),
        [only],
    );

    return sections;
};

export { useContactFormSections };
